import { render, staticRenderFns } from "./SMSTemplateEdit.vue?vue&type=template&id=1c5ae142&"
import script from "./SMSTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports